import { Injectable } from '@angular/core';
declare var $: any;

@Injectable()
export class Helpers {

  setDataTableSearchDelay() {
    var searchDelay = null;

    setTimeout(function () {
      $('.dataTables_filter input')
        .off('keyup.DT search.DT input.DT paste.DT cut.DT')
        .on('keyup.DT search.DT input.DT paste.DT cut.DT', function (e) {
          var search = $('div.dataTables_filter input').val();
          clearTimeout(searchDelay);

          searchDelay = setTimeout(function () {
            if (search != null) {
              $.fn.dataTable.tables({ api: true, visible: true }).search(search).draw();
            }
          }, 1000);
        });
    }, 1000);
  }

}
